import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import { isRtl } from '../../utils';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CLS_PREFIX } from '../../constants';
import Button from '../Button';
import Icon from '../Icon';
export default class Header extends Component {
  componentDidMount() {
    this.isRtl = isRtl();
  }

  renderBackButton() {
    const {
      baseClassName,
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(Button, {
      ghost: true,
      className: "".concat(baseClassName, "__back-button"),
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "chevron-left",
        flipHorizontal: this.isRtl,
        className: "".concat(baseClassName, "__icon")
      }),
      onClick: onClose
    });
  }

  renderHideButton() {
    const {
      baseClassName,
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(Button, {
      ghost: true,
      className: "".concat(baseClassName, "__button"),
      icon: /*#__PURE__*/React.createElement(Icon, {
        className: "".concat(baseClassName, "__icon"),
        name: "minimize"
      }),
      onClick: onClose
    });
  }

  renderCloseButton({
    disabled = false
  } = {}) {
    const {
      baseClassName,
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(Button, {
      ghost: true,
      className: "".concat(baseClassName, "__button"),
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: 'cross-mark',
        className: "".concat(baseClassName, "__icon")
      }),
      onClick: onClose,
      disabled: disabled
    });
  }

  render() {
    const {
      baseClassName,
      onClose,
      children,
      backButton,
      hideButton,
      ...props
    } = this.props;
    let prefix;
    let suffix;

    if (onClose) {
      switch (true) {
        case backButton:
          prefix = this.renderBackButton();
          break;

        case hideButton:
          suffix = /*#__PURE__*/React.createElement(React.Fragment, null, this.renderHideButton(), this.renderCloseButton({
            disabled: true
          }));
          break;

        default:
          suffix = this.renderCloseButton();
          break;
      }
    }

    return /*#__PURE__*/React.createElement("div", _extends({
      className: baseClassName
    }, props), prefix, /*#__PURE__*/React.createElement("h4", {
      className: "".concat(baseClassName, "__title")
    }, children), suffix);
  }

}

_defineProperty(Header, "propTypes", {
  baseClassName: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  backButton: PropTypes.bool,
  hideButton: PropTypes.bool
});

_defineProperty(Header, "defaultProps", {
  onClose: null,
  baseClassName: "".concat(CLS_PREFIX, "drawer-header"),
  backButton: false,
  hideButton: false
});